import * as React from "react";
import type { SVGProps } from "react";

const SvgContributions = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24.004}
        height={22}
        {...props}
    >
        <path
            fill="currentColor"
            d="M1.002 22.002a1 1 0 1 1 0-2h2.05a11.993 11.993 0 1 1 17.9 0h2.05a1 1 0 0 1 0 2Zm2.34-15a10 10 0 0 0 2.66 13h12.005a10 10 0 1 0-14.665-13Zm12.39-.352a3.259 3.259 0 0 1 1.653 1.979 3.234 3.234 0 0 1-.429 2.5l-1.61-.93a1.692 1.692 0 0 0 .255-1.238 1.446 1.446 0 0 0-.749-.926 1.255 1.255 0 0 0-1.188-.075 2.255 2.255 0 0 0-1.026 1l-.926 1.742 2.044 1.18-.809 1.4-2-1.154-.67 1.267a3.046 3.046 0 0 1-1.314 1.307l4.575 2.641-.828 1.419-6.9-3.981.822-1.423.539.311a.728.728 0 0 0 .66-.225 3.585 3.585 0 0 0 .737-.951l.707-1.33-1.058-.611.809-1.4 1.019.588.936-1.738a3.513 3.513 0 0 1 2.121-1.773 3.36 3.36 0 0 1 2.63.421Z"
        />
    </svg>
);
export default SvgContributions;
